import type { PropsWithChildren } from 'react';
import type { BreadcrumbItem } from '@/components/Breadcrumb';
import { PageNavigation } from '@/components/PageNavigation';
import { cn } from '@/utils/style';

type StickyHeaderPageProps = PropsWithChildren<{
  header?: React.ReactNode;
  title?: React.ReactNode;
  pathLink?: BreadcrumbItem[];
  topRightActions?: React.ReactNode;
  subHeader?: React.ReactNode;
  contentClassName?: string;
  badges?: React.ReactNode;
  dataTablePage?: boolean;
}>;

export function StickyHeaderPage({
  header,
  title,
  pathLink,
  topRightActions,
  subHeader,
  children,
  contentClassName,
  badges,
  dataTablePage = false,
}: StickyHeaderPageProps) {
  const titleElement = title && <h1 className="text-2xl font-semibold">{title}</h1>;
  const mainHeader = header ?? titleElement;

  return (
    <div className={`flex flex-col w-full ${dataTablePage ? 'h-full' : 'min-h-full'}`}>
      <div className="flex flex-col gap-1 bg-white p-2 border-b border-gray-200 flex-none md:sticky top-0 z-20">
        <PageNavigation pathLink={pathLink} />
        {topRightActions ? (
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <span className="flex items-center gap-2">
              {mainHeader}
              {badges}
            </span>
            <div className="flex items-center gap-2">{topRightActions}</div>
          </div>
        ) : (
          mainHeader
        )}
        {subHeader}
      </div>
      <div
        className={cn(
          'flex-1 min-h-0',
          dataTablePage ? 'overflow-x-auto' : 'p-6 space-y-6',
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
